export default __webpack_public_path__ + "static/pavel-bitmoji-5294e199d03bb120ac8aa70449eefb02.png";